import { Component, input } from '@angular/core';
import { PersonSimpleWithRole } from '@app/models/project.models';
import { LabeledContentComponent } from '@app/ui-components/labeled-content/labeled-content.component';

@Component({
  selector: 'app-name-connection-form',
  imports: [LabeledContentComponent],
  templateUrl: './name-connection-form.component.html',
  styleUrl: './name-connection-form.component.scss',
})
export class NameConnectionFormComponent {
  person = input.required<PersonSimpleWithRole>();
}
